var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change__container"},[_c('div',{staticClass:"change__bar",attrs:{"id":"bar1"}}),_c('div',{staticClass:"change__bar",attrs:{"id":"bar2"}}),_c('div',{staticClass:"change__bar",attrs:{"id":"bar3"}})])
}]

export { render, staticRenderFns }